export default {
  container: 'min-h-[400px] h-[calc(100vh-210px)]',
  toggleLoadingBox: 'absolute top-[256px] left-[46%] z-40',
  pricingLoadingBox: 'h-[600px] flex justify-center items-center',
  pricingSheetGridBox: 'h-full p-0',
  gridBox: 'mt-[10px]',
};

export const pricingSheetGrid = {
  stackStyle: 'h-[65vh]',
  togglePricingStyle: 'flex items-center',
  exportBtnBox:
    'w-full p-2 border-gray-400 rounded-xs border-b-0 border bg-[#F8F8F8]',
  muiGridStyle: 'ag-theme-alpine flex-1!',
  topBox: 'flex items-center justify-between',
  uploadSheetBtn: 'flex items-center gap-1',
};
